import { FC, memo, useEffect } from "react"
import { ShopBarEcomm } from "./shop-bar"

export const SiteHeaderEcomm: FC = memo(() => {
	useEffect(() => {
		const element = document.getElementById("app-main")
		if (element) {
			element.style.backgroundColor = "white"
		}
	})

	return (
		<header>
			<ShopBarEcomm />
		</header>
	)
})
